import { getUpcomingMeetings } from 'store/chat/services/getUpcomingMeetings.service';
import { upsertMeetings } from '../slices/chatSlice';

// Reminders fire 15 min before a meeting, so a 48-hour look-ahead is plenty and
// keeps the fetch cheap even when open-ended series have materialized dozens of
// future occurrences per thread.
const REMINDER_HORIZON_HOURS = 48;

/**
 * Seed the reminder scheduler with the user's upcoming meetings across the
 * threads it knows, in one call. Merges into the per-thread store (never
 * clobbers meetings a dialog already loaded in full).
 */
export const fetchUpcomingMeetings = (threadIds) => async (dispatch) => {
  const ids = (threadIds || []).filter(Boolean);
  if (ids.length === 0) return;
  try {
    const meetings = await getUpcomingMeetings(ids, {
      withinHours: REMINDER_HORIZON_HOURS,
    });
    if (Array.isArray(meetings) && meetings.length > 0) {
      dispatch(upsertMeetings(meetings));
    }
  } catch {
    // Reminders are best-effort; a failed fetch just means none this cycle.
  }
};
